import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, input, output } from '@angular/core';

const ANIMATION_TIMINGS = '500ms cubic-bezier(0.22, 0.68, 0, 1.71)';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  animations: [
    trigger('slideContent', [
      state('void', style({ transform: 'translateX(-20px)', opacity: 0 })),
      state('enter', style({ transform: 'translateX(0px)', opacity: 1 })),
      transition('* => *', animate(ANIMATION_TIMINGS)),
    ]),
  ],
  standalone: false,
})
export class ChipComponent {
  public readonly text = input('');
  public readonly wFull = input(false);
  public readonly accessoryRightClick = output<void>();
  public readonly accessoryLeftClick = output<void>();
  public animationState: 'void' | 'enter' = 'enter';
}
